import { GodziDropResultType, Loading, t } from '@slot-nx/core'
import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { GameType, useBetDetailStore } from '../../domain/betDetail/store/betDetailStore'
import { memo } from 'react'
import { BetDetailCloseButton } from './BetDetailCloseButton'
import { DrawBg } from './DrawBg'
import { DetailTab } from './DetailTab'
import { GameDetailUi } from './GameDetail/GameDetailUi'
import { GodziDetail } from './GodziDetail/GodziDetail'
import { DetailFooter } from './DetailFooter'

const popupWidth = 1080
const popupHeight = 1920

export const BetDetail = memo(() => {
  const [isFromOpBetDetail, isOpen, betDetailData, selectShowGameType, selectSpinType] = useBetDetailStore(x => [x.isFromOpBetDetail, x.isOpen, x.betDetailData, x.selectShowGameType, x.selectSpinType])

  if (!isOpen) return null
  if (!betDetailData) return <Loading x={popupWidth / 2} y={popupHeight / 2} width={100} height={100} />

  const godziDetail = betDetailData.godziDropResult
  const godziType = godziDetail ? godziDetail.type : GodziDropResultType.None
  const isMainGameDetail = selectShowGameType === GameType.MainGame

  const totalStake = (isMainGameDetail || !godziDetail) ? betDetailData.stake : godziDetail.effectiveStake
  const totalWinLose = (isMainGameDetail || !godziDetail) ? betDetailData.winLose : godziDetail.payout
  const totalPayout = (isMainGameDetail || !godziDetail) ? betDetailData.totalPayout : godziDetail.payout
  return (
    <Container name="BetDetail">
      <DrawBg name="BetDetailBackGround" x={0} y={0} width={popupWidth} height={popupHeight} backgroundColor="#000000" border={{ color: '#C1C1C1', width: 4 }} radius={20} />
      <Text name="betDetailTitle" text={t('betDetail_title')} x={popupWidth / 2} y={70} anchor={[0.5, 0.5]} style={new TextStyle({ fontSize: 54, fontWeight: '600', fill: '#FFFFFF' })} />
      <BetDetailCloseButton isFromOpBetDetail={isFromOpBetDetail} />
      <DetailTab godziResultType={godziType} isVoucherBet={betDetailData.voucherStake > 0} isFromOpBetDetail={isFromOpBetDetail} />
      <DrawBg name="DetailContentBackGround" x={10} y={200} width={1060} height={1700} radius={10} backgroundColor={selectShowGameType === GameType.MainGame ? '#2a2a2c' : '#4E0802'} />
      {(isMainGameDetail || !godziDetail)
        ? <GameDetailUi gameDetail={betDetailData.gameDetail} selectSpinType={selectSpinType} isFromOpBetDetail={isFromOpBetDetail} />
        : <GodziDetail godziDropResult={godziDetail} selectSpinType={selectSpinType} isFromOpBetDetail={isFromOpBetDetail} /> }
      <Text name="refNo" text={`${t('betDetail_refNo')} ${betDetailData.refNo}`} x={540} y={1650} anchor={[0.5, 0.5]} style={new TextStyle({ fontSize: 42, fontWeight: 'bold', fill: '#F7E584' })} />
      <DetailFooter totalStake={totalStake} totalWinLose={totalWinLose} totalPayout={totalPayout} voucherStake={betDetailData.voucherStake} />
    </Container>
  )
})
